import { render, staticRenderFns } from "./DatePickerFull.vue?vue&type=template&id=163b4a60&scoped=true&"
import script from "./DatePickerFull.vue?vue&type=script&lang=js&"
export * from "./DatePickerFull.vue?vue&type=script&lang=js&"
import style0 from "./DatePickerFull.vue?vue&type=style&index=0&id=163b4a60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "163b4a60",
  null
  
)

export default component.exports